import { EditorState } from "prosemirror-state";

export enum RichTextEditorStateKind {
	Unknown = 0,
	ProseMirror = 1
}

type UnknownRichTextEditorState = {
	kind: RichTextEditorStateKind.Unknown;
};

export type ProseMirrorRichTextEditorState = {
	kind: RichTextEditorStateKind.ProseMirror;
	editorState: EditorState;
};

export type RichTextEditorState =
	| UnknownRichTextEditorState
	| ProseMirrorRichTextEditorState;

export function isProseMirror(state: RichTextEditorState): state is ProseMirrorRichTextEditorState {
	return state.kind === RichTextEditorStateKind.ProseMirror;
}